// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d413fffe","732":"61f9cad3"}[chunkId] + ".chunk.js";
};